import { arrayOf, bool, oneOf, number, shape, string } from 'prop-types'

import { EventLevels } from '../../models/notifications/event-levels-enum'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { eventMessagePropType } from './event-message-prop-type'
import { objectEventControlFlagPropType } from './object-event-control-flag-prop-type'
import { objectEventResolutionPropType } from './object-event-resolution-prop-type'

export const objectEventPropType = shape({
    acknowledged: bool.isRequired,
    acknowledgement: objectEventResolutionPropType,
    addressId: string,
    controlFlags: arrayOf(objectEventControlFlagPropType),
    currentEventLevel: oneOf(Object.values(EventLevels)).isRequired,
    eventId: string.isRequired,
    eventMessage: eventMessagePropType,
    eventTime: string.isRequired,
    lastModified: string,
    locationDescription: locationDescriptionPropType,
    objectId: string.isRequired,
    originalEventLevel: oneOf(Object.values(EventLevels)).isRequired,
    position: positionPropType,
    positionTime: string,
    repeatCount: number,
    resolution: objectEventResolutionPropType,
    resolved: bool.isRequired
})
